import React from 'react'

const Footer = () => {
    return (
        <div className="footer">
            &copy; FLARE Copyright 2021. All rights reserved.
        </div>
    )
}

export default Footer
